(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-thumbnails"] && !Shopify.designMode) return;
  try {
    const thumbnailSelector =
    '.variant-thumbnail[data-preview-image]';

  const originalImageStates = new WeakMap();

  function findMainProductImage(thumbnail) {
    const gallery = thumbnail.closest('.card-gallery');

    if (!gallery) return null;

    return (
      gallery.querySelector(
        'slideshow-slide[aria-hidden="false"] .product-media__image'
      ) ||
      gallery.querySelector(
        'slideshow-slide[aria-hidden="false"] img'
      ) ||
      gallery.querySelector(
        '.product-media-container .product-media__image'
      ) ||
      gallery.querySelector(
        '.product-media-container img'
      )
    );
  }

  function setAttributeOrRemove(element, attribute, value) {
    if (value === null || value === '') {
      element.removeAttribute(attribute);
      return;
    }

    element.setAttribute(attribute, value);
  }

  function previewVariantImage(thumbnail) {
    const previewUrl = thumbnail.dataset.previewImage;
    const mainImage = findMainProductImage(thumbnail);
    const thumbnailsContainer = thumbnail.closest(
      '.variant-thumbnails'
    );

    if (!previewUrl || !mainImage) return;

    if (thumbnail.classList.contains('is-active')) return;

    thumbnailsContainer
      ?.querySelectorAll('.variant-thumbnail.is-active')
      .forEach((item) => item.classList.remove('is-active'));

    thumbnail.classList.add('is-active');

    if (!originalImageStates.has(mainImage)) {
      originalImageStates.set(mainImage, {
        src: mainImage.getAttribute('src'),
        srcset: mainImage.getAttribute('srcset'),
        sizes: mainImage.getAttribute('sizes'),
        alt: mainImage.getAttribute('alt')
      });
    }

    mainImage.dataset.variantPreviewing = 'true';
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');

    mainImage.style.opacity = '0.65';

    mainImage.setAttribute('src', previewUrl);

    if (thumbnail.dataset.previewAlt) {
      mainImage.setAttribute(
        'alt',
        thumbnail.dataset.previewAlt
      );
    }

    requestAnimationFrame(() => {
      mainImage.style.opacity = '1';
    });
  }

  function restoreOriginalImage(thumbnailsContainer) {
    const gallery = thumbnailsContainer.closest('.card-gallery');

    if (!gallery) return;

    const mainImage = gallery.querySelector(
      'img[data-variant-previewing="true"]'
    );

    if (!mainImage) return;

    const originalState = originalImageStates.get(mainImage);

    if (!originalState) return;

    setAttributeOrRemove(
      mainImage,
      'src',
      originalState.src
    );

    setAttributeOrRemove(
      mainImage,
      'srcset',
      originalState.srcset
    );

    setAttributeOrRemove(
      mainImage,
      'sizes',
      originalState.sizes
    );

    setAttributeOrRemove(
      mainImage,
      'alt',
      originalState.alt
    );

    delete mainImage.dataset.variantPreviewing;
    originalImageStates.delete(mainImage);

    thumbnailsContainer
      .querySelectorAll('.variant-thumbnail.is-active')
      .forEach((item) => item.classList.remove('is-active'));
  }

  document.addEventListener('pointerover', (event) => {
    const thumbnail = event.target.closest?.(
      thumbnailSelector
    );

    if (!thumbnail) return;

    previewVariantImage(thumbnail);
  });

  document.addEventListener('pointerout', (event) => {
    const thumbnailsContainer = event.target.closest?.(
      '.variant-thumbnails'
    );

    if (!thumbnailsContainer) return;

    if (
      event.relatedTarget &&
      thumbnailsContainer.contains(event.relatedTarget)
    ) {
      return;
    }

    restoreOriginalImage(thumbnailsContainer);
  });

  document.addEventListener('focusin', (event) => {
    const thumbnail = event.target.closest?.(
      thumbnailSelector
    );

    if (!thumbnail) return;

    previewVariantImage(thumbnail);
  });

  document.addEventListener('focusout', (event) => {
    const thumbnailsContainer = event.target.closest?.(
      '.variant-thumbnails'
    );

    if (!thumbnailsContainer) return;

    if (
      event.relatedTarget &&
      thumbnailsContainer.contains(event.relatedTarget)
    ) {
      return;
    }

    restoreOriginalImage(thumbnailsContainer);
  });
  } catch(e) { console.error(e); }
})();

})();
